/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "es-419": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-AR": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} días",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} días",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} días",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} días",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} seg.",
            "other": "dentro de {0} seg."
          },
          "past": {
            "one": "hace {0} seg.",
            "other": "hace {0} seg."
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} seg.",
            "other": "dentro de {0} seg."
          },
          "past": {
            "one": "hace {0} seg.",
            "other": "hace {0} seg."
          }
        }
      },
      "es-BO": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-BR": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-BZ": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-CL": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-CO": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-CR": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-CU": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-DO": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-EA": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-EC": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-GQ": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-GT": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-HN": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-IC": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-MX": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el año próximo",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "en {0} a",
            "other": "en {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "en {0} a",
            "other": "en {0} a"
          },
          "past": {
            "one": "-{0} a",
            "other": "-{0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "en {0} trimestre",
            "other": "dentro de {0} trimetres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "en {0} trim.",
            "other": "en {0} trim"
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "en {0} trim.",
            "other": "en {0} trim."
          },
          "past": {
            "one": "-{0} T",
            "other": "-{0} T"
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el mes próximo",
          "future": {
            "one": "en {0} mes",
            "other": "en {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "en {0} m",
            "other": "en {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "+{0} m",
            "other": "+{0} m"
          },
          "past": {
            "one": "-{0} m",
            "other": "-{0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la semana próxima",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "en {0} sem.",
            "other": "en {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "en {0} día",
            "other": "en {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "+{0} día",
            "other": "en {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "en {0} h",
            "other": "en {0} n"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "en {0} min",
            "other": "en {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "en {0} min",
            "other": "en {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "en {0} s",
            "other": "en {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-NI": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-PA": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-PE": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-PH": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-PR": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-PY": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} seg.",
            "other": "dentro de {0} seg."
          },
          "past": {
            "one": "hace {0} seg.",
            "other": "hace {0} seg."
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} seg.",
            "other": "dentro de {0} seg."
          },
          "past": {
            "one": "hace {0} seg.",
            "other": "hace {0} seg."
          }
        }
      },
      "es-SV": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "antier",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-US": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el año próximo",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimetre",
            "other": "dentro de {0} trimetres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el mes próximo",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la semana próxima",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-UY": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es-VE": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. pas."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      },
      "es": {
        "nu": ["latn"],
        "year": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} año",
            "other": "dentro de {0} años"
          },
          "past": {
            "one": "hace {0} año",
            "other": "hace {0} años"
          },
          "-1": "el año pasado"
        },
        "year-short": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "year-narrow": {
          "0": "este año",
          "1": "el próximo año",
          "future": {
            "one": "dentro de {0} a",
            "other": "dentro de {0} a"
          },
          "past": {
            "one": "hace {0} a",
            "other": "hace {0} a"
          },
          "-1": "el año pasado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "hace {0} trimestre",
            "other": "hace {0} trimestres"
          },
          "-1": "el trimestre pasado"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "el próximo trimestre",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "hace {0} trim.",
            "other": "hace {0} trim."
          },
          "-1": "el trimestre pasado"
        },
        "month": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} mes",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "hace {0} mes",
            "other": "hace {0} meses"
          },
          "-1": "el mes pasado"
        },
        "month-short": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "month-narrow": {
          "0": "este mes",
          "1": "el próximo mes",
          "future": {
            "one": "dentro de {0} m",
            "other": "dentro de {0} m"
          },
          "past": {
            "one": "hace {0} m",
            "other": "hace {0} m"
          },
          "-1": "el mes pasado"
        },
        "week": {
          "0": "esta semana",
          "1": "la próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "hace {0} semana",
            "other": "hace {0} semanas"
          },
          "-1": "la semana pasada"
        },
        "week-short": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "week-narrow": {
          "0": "esta sem.",
          "1": "próx. sem.",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "hace {0} sem.",
            "other": "hace {0} sem."
          },
          "-1": "sem. ant."
        },
        "day": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-short": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "day-narrow": {
          "0": "hoy",
          "1": "mañana",
          "2": "pasado mañana",
          "future": {
            "one": "dentro de {0} día",
            "other": "dentro de {0} días"
          },
          "past": {
            "one": "hace {0} día",
            "other": "hace {0} días"
          },
          "-2": "anteayer",
          "-1": "ayer"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "hace {0} hora",
            "other": "hace {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "hace {0} h",
            "other": "hace {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "hace {0} minuto",
            "other": "hace {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "hace {0} min",
            "other": "hace {0} min"
          }
        },
        "second": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "hace {0} segundo",
            "other": "hace {0} segundos"
          }
        },
        "second-short": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        },
        "second-narrow": {
          "0": "ahora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "hace {0} s",
            "other": "hace {0} s"
          }
        }
      }
    },
    "availableLocales": ["es-419", "es-AR", "es-BO", "es-BR", "es-BZ", "es-CL", "es-CO", "es-CR", "es-CU", "es-DO", "es-EA", "es-EC", "es-GQ", "es-GT", "es-HN", "es-IC", "es-MX", "es-NI", "es-PA", "es-PE", "es-PH", "es-PR", "es-PY", "es-SV", "es-US", "es-UY", "es-VE", "es"]
  });
}